import Angular from "angular";
import Loader from "angular-ecmascript/module-loader";
import {Service} from "angular-ecmascript/module-helpers";
import Filter from "../model/filter.model";
import Vehicle from "../model/vehicle.model";
import VehicleCheck from "../model/vehiclecheck.model";
import Settings from "../providers/settings.provider";

export var Name = 'Vehicles';

export class VehiclesFilter extends Filter {

    static load = function (name) {
        return Filter.load(name, VehiclesFilter);
    };

    constructor(data) {
        super(data);

        this.sortBy = 'tagNumber';
        this.search = null;
        this.hu = null;
        this.leasingVehicle = null;
        this.fleetsVehicle = null;
        this.vehicleId = null;
        this.customerId = null;

        if (data) {
            Object.assign(this, data);
        }
    }

    active() {
        if (this.search != null
            || this.hu == true
            || this.leasingVehicle != null
            || this.fleetsVehicle != null
            || this.vehicleId != null
            || this.customerId != null) {

            return true;
        }

        return false;
    }

    reset() {
        super.reset();
        this.sortBy = 'tagNumber';
        this.search = null;
        this.hu = null;
        this.leasingVehicle = null;
        this.fleetsVehicle = null;
        this.vehicleId = null;
        this.customerId = null;
    }

}

export class Vehicles extends Service {
    static $name = Name;
    static $inject = ['$q', 'Restangular', 'settings'];

    create() {
        // NOOP.
    }

    get(vehicleId) {
        let defer = this.$q.defer();

        this.Restangular
            .setBaseUrl(this.settings.httpUrl('app'))
            .one('vehicle', vehicleId)
            .get()
            .then((vehicleData) => {
                defer.resolve(this.Restangular.copy(new Vehicle(vehicleData)));
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise;
    }

    find(vehiclesFilter) {
        let defer = this.$q.defer();

        this.Restangular
            .setBaseUrl(this.settings.httpUrl('app'))
            .all('vehicles')
            .post(vehiclesFilter)
            .then((response) => {
                response.data = response.data.map((vehicleData) => {
                    return this.Restangular.copy(new Vehicle(vehicleData));
                });

                defer.resolve(response);
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise
    }

    allVehicleChecks(vehicleId) {
        let defer = this.$q.defer();

        this.Restangular
            .setBaseUrl(this.settings.httpUrl('app'))
            .one('vehicle', vehicleId)
            .one('checks')
            .getList()
            .then((response) => {
                var data = response.map((vehicleCheckData) => {
                    return this.Restangular.copy(new VehicleCheck(vehicleCheckData));
                });

                defer.resolve(data);
            })
            .catch((err) => {
                defer.reject(err);
            });

        return defer.promise
    }

}


let VehiclesModule = Angular.module('vehicles-service', ['restangular', Settings.name]);

new Loader(VehiclesModule)
    .load(Vehicles);

export default VehiclesModule;



// WEBPACK FOOTER //
// ./src/modules/main/services/vehicles.service.js